import { render, staticRenderFns } from "./EtsyTransferShopTableMobile.vue?vue&type=template&id=039960e2&scoped=true"
import script from "./EtsyTransferShopTableMobile.vue?vue&type=script&lang=js"
export * from "./EtsyTransferShopTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039960e2",
  null
  
)

export default component.exports